// The event's map slot is authoritative; comp and players are compatibility
// projections used by the existing VOD filters and Team Metrics Studio.
export function lineupProjection(slot) {
  if (!Array.isArray(slot?.lineup)) return {};
  return {
    comp: slot.lineup.map(row => row.agent).filter(Boolean),
    players: slot.lineup.filter(row => row.uid || row.username).map(row => ({uid: row.uid || "", username: row.username || "Member", agent: row.agent || ""})),
  };
}
export function validateLineup(rows) {
  if (!Array.isArray(rows) || rows.length > 5) throw new Error("Choose up to five players and agents.");
  const normalized = rows.map(row => ({uid: String(row.uid || "").trim(), username: String(row.username || "").trim(), agent: String(row.agent || "").trim()})).filter(row => row.uid || row.username || row.agent);
  const players = normalized.map(row => row.uid || row.username.toLowerCase()).filter(Boolean);
  const agents = normalized.map(row => row.agent).filter(Boolean);
  if (new Set(players).size !== players.length) throw new Error("Each player can appear only once in this map's lineup.");
  if (new Set(agents).size !== agents.length) throw new Error("Each agent can appear only once in this map's lineup.");
  return normalized;
}
export function legacyLineup(record = {}) {
  const players = record.players || [];
  // Old independent player/agent arrays have no trustworthy pairing order.
  if (players.some(row => row.agent)) return players.map(row => ({uid: row.uid || "", username: row.username || "", agent: row.agent || ""}));
  if (record.comp?.length) return record.comp.slice(0,5).map(agent => ({uid: "", username: "", agent}));
  return players.slice(0,5).map(row => ({uid: row.uid || "", username: row.username || "", agent: ""}));
}

// Pairings identify a preset independently of usernames or display order.
export function lineupSignature(rows = []) {
  return JSON.stringify(rows.map(row => [row.uid || String(row.username || "").toLowerCase(), row.agent || ""]).sort((a,b) => JSON.stringify(a).localeCompare(JSON.stringify(b))));
}
